import { render, staticRenderFns } from "./HostedPaymentAmount.vue?vue&type=template&id=5182cc5e&"
import script from "./HostedPaymentAmount.vue?vue&type=script&lang=ts&"
export * from "./HostedPaymentAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports